import { render, staticRenderFns } from "./LeaveWarningModal.vue?vue&type=template&id=60a8932c&scoped=true"
import script from "./LeaveWarningModal.vue?vue&type=script&lang=js"
export * from "./LeaveWarningModal.vue?vue&type=script&lang=js"
import style0 from "./LeaveWarningModal.vue?vue&type=style&index=0&id=60a8932c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a8932c",
  null
  
)

export default component.exports